import React from "react";

const VideoPlayer = ({ video }) => {
  if (!video) {
    return <div>Loading...</div>;
  }

  return (
    <div className="video-player">
      <div className="ui embed">
        <iframe
          title={video.snippet.title}
          width="560"
          height="315"
          src={`https://www.youtube.com/embed/${video.id.videoId}`}
          frameBorder="0"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>
      </div>
      <div className="ui segment">
        <h4>{video.snippet.title}</h4>

        <p>{video.snippet.description}</p>
      </div>
    </div>
  );
};

export default VideoPlayer;
